import { Component, OnInit, Input, Inject } from '@angular/core';
import { NeedHelpService } from '../../api/services/need-help.service';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { APP_CONFIG } from '../../api/config';

@Component({
  selector: 'virtual-assistant',
  templateUrl: './virtual-assistant.component.html',
  styleUrls: ['./virtual-assistant.component.scss'],
  providers: [NeedHelpService]
})
export class VirtualAssistantComponent implements OnInit {
  @Input() messages;
  @Input() isRightBorderDisplayed: boolean;

  appConfig: IAppConfig;
  brandCode: string;
  isSupported: boolean;

  constructor(@Inject(APP_CONFIG) appConfig: IAppConfig, private needHelpService: NeedHelpService) {
    this.appConfig = appConfig;
  }

  ngOnInit() {
    this.brandCode = this.appConfig.brand.brandCode;
    this.isSupported = this.needHelpService.isVirtualAssistantSupported();
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/virtual-assistant/virtual-assistant.component.ts